// extracted by mini-css-extract-plugin
export default {"container":"Textarea_container__3S-AL","color-primary":"Textarea_color-primary__ufag9","active":"Textarea_active__MuJNe"};